/* Navratri festive motion — only runs while html.wl-navratri is set (see snippets/wl-navratri-mode.liquid).
   1) Marigold petals tumbling in 3D down the home page (fixed canvas, sparse, paused when hidden).
   2) Hero: mirror-work glints twinkling and warm diya embers rising (only while the hero is on screen).
   3) Nine-colours cards: pointer-driven 3D tilt on desktop.
   4) Cart icons twirl like a dandiya when the cart count goes up (site-wide).
   Everything is skipped for prefers-reduced-motion and Save-Data. */
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('wl-navratri')) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  if (reduce || conn.saveData) return;

  var DPR = Math.min(window.devicePixelRatio || 1, 2);
  var mobile = window.innerWidth < 750;
  var TAU = Math.PI * 2;
  var rand = function (a, b) { return a + Math.random() * (b - a); };

  function makeCanvas(cls, parent) {
    var c = document.createElement('canvas');
    c.className = cls;
    c.setAttribute('aria-hidden', 'true');
    parent.appendChild(c);
    return c;
  }
  function fit(c, w, h) {
    c.width = Math.round(w * DPR);
    c.height = Math.round(h * DPR);
    c.style.width = w + 'px';
    c.style.height = h + 'px';
    var ctx = c.getContext('2d');
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    return ctx;
  }

  /* ---- 1. Petals ---------------------------------------------------------------- */
  function petals() {
    if (!html.hasAttribute('data-nv-petals')) return;
    var c = makeCanvas('wl-nv-petals', document.body);
    var W, H, ctx;
    var resize = function () { W = window.innerWidth; H = window.innerHeight; ctx = fit(c, W, H); };
    resize();
    window.addEventListener('resize', resize, { passive: true });
    var palette = ['#F39A1E', '#F6C324', '#E8761B', '#FFB23F', '#D9661A', '#B3263A'];
    var n = mobile ? 7 : 13;
    var P = [];
    var spawn = function (p, top) {
      p.x = rand(0, W); p.y = top ? rand(-H, 0) - 20 : rand(0, H);
      p.s = rand(5, mobile ? 9 : 11); p.vy = rand(14, 30); p.sway = rand(10, 28);
      p.ph = rand(0, TAU); p.fs = rand(.6, 1.6); p.rot = rand(0, TAU); p.vr = rand(-.8, .8);
      p.col = palette[(Math.random() * (Math.random() < .12 ? palette.length : palette.length - 1)) | 0];
      return p;
    };
    for (var i = 0; i < n; i++) P.push(spawn({}, false));
    var lastY = window.scrollY, push = 0;
    window.addEventListener('scroll', function () { var y = window.scrollY; push += (y - lastY) * .18; lastY = y; }, { passive: true });
    var last = 0, raf = 0;
    var draw = function (t) {
      raf = requestAnimationFrame(draw);
      var dt = last ? Math.min((t - last) / 1000, .05) : 0; last = t;
      ctx.clearRect(0, 0, W, H);
      var dy = push; push *= .86;
      for (var i = 0; i < P.length; i++) {
        var p = P[i];
        p.ph += dt * p.fs; p.rot += dt * p.vr;
        p.y += p.vy * dt - dy * (p.s / 10);
        var x = p.x + Math.sin(p.ph) * p.sway;
        if (p.y > H + 20) spawn(p, true);
        if (p.y < -60) p.y = H + 10;
        var flip = Math.cos(p.ph * 1.7);
        ctx.save();
        ctx.translate(x, p.y);
        ctx.rotate(p.rot);
        ctx.scale(1, .35 + .65 * Math.abs(flip));
        ctx.globalAlpha = .82;
        ctx.fillStyle = p.col;
        ctx.beginPath();
        ctx.moveTo(0, -p.s);
        ctx.bezierCurveTo(p.s * .9, -p.s * .5, p.s * .7, p.s * .7, 0, p.s);
        ctx.bezierCurveTo(-p.s * .7, p.s * .7, -p.s * .9, -p.s * .5, 0, -p.s);
        ctx.fill();
        ctx.globalAlpha = .28;
        ctx.strokeStyle = flip > 0 ? '#7a3a06' : '#fff3d0';
        ctx.lineWidth = .8;
        ctx.beginPath(); ctx.moveTo(0, -p.s * .7); ctx.lineTo(0, p.s * .7); ctx.stroke();
        ctx.restore();
      }
    };
    var run = function () { if (!raf) { last = 0; raf = requestAnimationFrame(draw); } };
    var stop = function () { cancelAnimationFrame(raf); raf = 0; };
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : run(); });
    run();
  }

  /* ---- 2. Hero glints + embers ---------------------------------------------------- */
  function heroGlints() {
    var hero = document.querySelector('.wl-hero');
    if (!hero) return;
    var c = makeCanvas('wl-nv-hero-fx', hero);
    var W, H, ctx;
    var resize = function () { W = hero.clientWidth; H = hero.clientHeight; ctx = fit(c, W, H); };
    resize();
    window.addEventListener('resize', resize, { passive: true });
    var G = [], E = [];
    var ng = mobile ? 12 : 22, ne = mobile ? 10 : 18;
    var newG = function (g) { g.x = rand(0, W); g.y = rand(H * .15, H); g.s = rand(2.5, 6); g.t = rand(0, 1); g.sp = rand(.35, .8); return g; };
    var newE = function (e, init) { e.x = rand(0, W); e.y = init ? rand(0, H) : H + 10; e.r = rand(1.2, 3.4); e.vy = rand(10, 26); e.ph = rand(0, TAU); e.a = rand(.35, .8); return e; };
    for (var i = 0; i < ng; i++) G.push(newG({}));
    for (var j = 0; j < ne; j++) E.push(newE({}, true));
    var star = function (x, y, s, a) {
      ctx.globalAlpha = a;
      ctx.fillStyle = '#FFF4D6';
      ctx.beginPath();
      ctx.moveTo(x, y - s); ctx.quadraticCurveTo(x, y, x + s, y); ctx.quadraticCurveTo(x, y, x, y + s);
      ctx.quadraticCurveTo(x, y, x - s, y); ctx.quadraticCurveTo(x, y, x, y - s); ctx.fill();
      ctx.globalAlpha = a * .5;
      ctx.beginPath(); ctx.arc(x, y, s * .45, 0, TAU); ctx.fill();
    };
    var last = 0, raf = 0, visible = false;
    var draw = function (t) {
      raf = requestAnimationFrame(draw);
      var dt = last ? Math.min((t - last) / 1000, .05) : 0; last = t;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < E.length; i++) {
        var e = E[i];
        e.y -= e.vy * dt; e.ph += dt;
        if (e.y < H * .25) e.a -= dt * .25;
        if (e.y < -10 || e.a <= 0) newE(e, false);
        var x = e.x + Math.sin(e.ph) * 6;
        var gr = ctx.createRadialGradient(x, e.y, 0, x, e.y, e.r * 4);
        gr.addColorStop(0, 'rgba(255,214,120,' + e.a + ')');
        gr.addColorStop(1, 'rgba(255,170,60,0)');
        ctx.globalAlpha = 1; ctx.fillStyle = gr;
        ctx.beginPath(); ctx.arc(x, e.y, e.r * 4, 0, TAU); ctx.fill();
      }
      for (var k = 0; k < G.length; k++) {
        var g = G[k];
        g.t += dt * g.sp;
        if (g.t >= 1) newG(g), g.t = 0;
        var a = Math.sin(g.t * Math.PI);
        star(g.x, g.y, g.s * (.6 + a * .6), a * .9);
      }
      ctx.globalCompositeOperation = 'source-over';
    };
    var run = function () { if (!raf && visible && !document.hidden) { last = 0; raf = requestAnimationFrame(draw); } };
    var stop = function () { cancelAnimationFrame(raf); raf = 0; };
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; visible ? run() : stop(); }).observe(hero);
    } else { visible = true; run(); }
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : run(); });
  }

  /* ---- 3. 3D tilt on the nine-colours cards (fine pointers only) ------------------ */
  function tilt() {
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    [].forEach.call(document.querySelectorAll('.wl-nv-card'), function (card) {
      var inner = card.querySelector('.wl-nv-inner');
      if (!inner) return;
      card.addEventListener('pointermove', function (ev) {
        var r = card.getBoundingClientRect();
        var px = (ev.clientX - r.left) / r.width - .5, py = (ev.clientY - r.top) / r.height - .5;
        inner.style.setProperty('--rx', (-py * 10).toFixed(2) + 'deg');
        inner.style.setProperty('--ry', (px * 12).toFixed(2) + 'deg');
        inner.style.setProperty('--gx', ((px + .5) * 100).toFixed(1) + '%');
        inner.style.setProperty('--gy', ((py + .5) * 100).toFixed(1) + '%');
        card.classList.add('is-tilting');
      });
      card.addEventListener('pointerleave', function () {
        inner.style.setProperty('--rx', '0deg'); inner.style.setProperty('--ry', '0deg');
        card.classList.remove('is-tilting');
      });
    });
  }

  /* ---- 4. Cart icon twirl when the count goes up ---------------------------------- */
  function cartTwirl() {
    var hosts = document.querySelectorAll('a[href="/cart"][aria-controls="CartDrawer"]');
    [].forEach.call(hosts, function (host) {
      var read = function () { var m = (host.textContent || '').match(/\d+/); return m ? +m[0] : 0; };
      var prev = read();
      new MutationObserver(function () {
        var now = read();
        if (now > prev) {
          var icon = host.querySelector('svg') || host;
          icon.classList.remove('wl-nv-twirl'); void icon.getBoundingClientRect(); icon.classList.add('wl-nv-twirl');
          setTimeout(function () { icon.classList.remove('wl-nv-twirl'); }, 1100);
        }
        prev = now;
      }).observe(host, { subtree: true, childList: true, characterData: true });
    });
  }

  var boot = function () {
    try { petals(); } catch (e) {}
    try { heroGlints(); } catch (e) {}
    try { tilt(); } catch (e) {}
    try { cartTwirl(); } catch (e) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Festive kit — runs on every page, including for reduced-motion users (it only adds static
   markup; the CSS decides whether anything moves). Re-applies when the cart drawer, cart page
   or quick views re-render. */
(function () {
  var html = document.documentElement;
  if (!html.classList.contains('wl-navratri')) return;
  var NV = window.WL_NV || { start: '2026-10-11', nights: [] };
  var BEAT = 3200;
  var iso = function (ms) { return new Date(ms).toISOString().slice(0, 10); };
  var today = iso(Date.now() + 198e5);
  var dayMs = 864e5;
  var tomorrow = iso(Date.parse(today + 'T00:00:00Z') + dayMs);
  var esc = function (s) { var t = document.createElement('span'); t.textContent = s; return t.innerHTML; };

  function el(tag, cls, htmlStr) { var e = document.createElement(tag); e.className = cls; if (htmlStr) e.innerHTML = htmlStr; return e; }
  function stick(side) { var i = el('i', 'wl-nv-stick wl-nv-stick--' + side); i.setAttribute('aria-hidden', 'true'); return i; }
  function cross() { var i = el('i', 'wl-nv-x'); i.setAttribute('aria-hidden', 'true'); return i; }

  function decorate() {
    // Section headings with a pseudo eyebrow ("Complete the look", "Recently viewed"…) — lift the
    // eyebrow into real markup so it can be flanked by a striking pair of dandiyas.
    [].forEach.call(document.querySelectorAll('.hdt-heading-block:not([data-nv])'), function (h) {
      h.setAttribute('data-nv', '');
      var c = getComputedStyle(h, '::before').content;
      if (!c || c === 'none' || c === 'normal' || c === '""') return;
      var eb = el('div', 'wl-nv-hb-eb');
      eb.appendChild(stick('l')); eb.appendChild(el('span', '', esc(c.replace(/^["']|["']$/g, '')))); eb.appendChild(stick('r'));
      h.parentNode.insertBefore(eb, h);
      h.classList.add('wl-nv-hb');
    });
    // Left-aligned row headings get a single leading dandiya, same as on the home page.
    [].forEach.call(document.querySelectorAll('.hdt-minicart-recommendations__title:not([data-nv]), .wl-offers__head:not([data-nv]), .wl-gift__label:not([data-nv]), .wl-sum__head:not([data-nv])'), function (h) {
      h.setAttribute('data-nv', '');
      h.insertBefore(stick('l'), h.firstChild);
      h.classList.add('wl-nv-row');
    });
    // "Navratri" tag on every Festive Edit link outside the desktop mega-nav.
    [].forEach.call(document.querySelectorAll('a.hdt--menu_item[href$="/collections/festive-edit"]:not([data-nv]), .wl-menu__list a[href$="/collections/festive-edit"]:not([data-nv]), a.wl-search-cat[href$="/collections/festive-edit"]:not([data-nv])'), function (a) {
      a.setAttribute('data-nv', '');
      a.appendChild(el('span', 'wl-nv-tag', 'Navratri'));
    });
    // Mirror-work glint on the product page purchase buttons.
    [].forEach.call(document.querySelectorAll('.hdt-product-form__submit, .hdt-sticky-atc__submit'), function (b) {
      if (!b.querySelector(':scope > .wl-nv-glint')) b.appendChild(el('span', 'wl-nv-glint'));
    });
    // Day-N chips: flag tonight / tomorrow, retire nights that have passed.
    [].forEach.call(document.querySelectorAll('.wl-nv-cday[data-nv-date]:not([data-nv]), .wl-nv-pday[data-nv-date]:not([data-nv])'), function (c) {
      c.setAttribute('data-nv', '');
      var d = c.getAttribute('data-nv-date');
      if (d < today) { c.classList.add('is-past'); return; }
      var when = d === today ? 'Tonight' : d === tomorrow ? 'Tomorrow' : '';
      if (!when) return;
      c.classList.add('is-soon');
      var tag = c.querySelector('[data-nv-when]');
      if (tag) { tag.textContent = when; tag.hidden = false; }
      else c.insertAdjacentHTML('beforeend', '<span class="wl-nv-cday__when">' + when + '</span>');
    });
    syncBeat();
  }

  // Every dandiya on the page strikes on one shared beat, wherever and whenever it was added.
  function syncBeat() {
    if (!document.getAnimations) return;
    document.getAnimations().forEach(function (a) {
      if (a.animationName === 'wl-nv-tap' && a.startTime !== 0) { try { a.startTime = 0; } catch (e) {} }
    });
  }

  var queued = false;
  var schedule = function () { if (queued) return; queued = true; setTimeout(function () { queued = false; try { decorate(); } catch (e) {} }, 120); };
  var start = function () {
    try { decorate(); } catch (e) {}
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', syncBeat);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
